// src/lib/storeWeek.js
// STATUS: active | UPDATED: 2026-09-27
// LOG:
//   2026-09-27  New. The store's last seven days of management discipline,
//               read once and shared by the team page and the owner's weekly
//               check-in on Today. Moved out of OwnerDisciplines.jsx rather
//               than copied, so the two screens cannot disagree about a week.
//
// The arithmetic is ownerWeek.js, which is pure and tested. This file is the
// reads, which is why it is separate: it imports supabase.
//
// `error` is set when any read failed, and a failed audit read is passed on as
// null rather than an empty list, because zero audits on these screens says a
// manager did not inspect their floor. See CLAUDE.md, the silent bugs.

import { supabase } from './supabase'
import { listRecent as listOneOnOnes, listFloor } from './oneOnOne'
import { listRecent as listMeetings } from './morningMeeting'
import { listSignoffs } from './signoffs'
import { lastDays, disciplineRows, WINDOW_DAYS } from './ownerWeek'

export async function loadStoreWeek(dealershipId) {
  if (!dealershipId) return { rows: [], floor: [], floorSize: 0, error: null }
  const days = lastDays(WINDOW_DAYS)
  const since = days[days.length - 1]

  const [floor, meetings, ones, signoffs, audits] = await Promise.all([
    listFloor(dealershipId),
    listMeetings(dealershipId, WINDOW_DAYS + 2),
    listOneOnOnes(dealershipId, 120),
    listSignoffs(),
    // The audit is per manager and there is no lib for reading somebody
    // else's, so it is read here. RLS decides what comes back.
    supabase.from('manager_audit').select('on_date, items').gte('on_date', since),
  ])

  return {
    floor: floor.data,
    floorSize: floor.data.length,
    rows: disciplineRows({
      days,
      meetings: meetings.data,
      oneOnOnes: ones.data,
      audits: audits.error ? null : audits.data || [],
      signoffs: signoffs.signoffs || [],
      floorSize: floor.data.length,
    }),
    error:
      floor.error || meetings.error || ones.error || audits.error
        ? 'Some of this week could not be read.'
        : null,
  }
}
